var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.toggleMode}},[_c('transition',{attrs:{"name":"flip","mode":"out-in"}},[(!_vm.dark)?_c('span',{staticClass:"tgl-btn"},[_vm._v("Light")]):_c('span',{staticClass:"tgl-btn"},[_vm._v("Dark")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }